import { render, staticRenderFns } from "./QuestionOrder.vue?vue&type=template&id=920dd5ce&"
import script from "./QuestionOrder.vue?vue&type=script&lang=js&"
export * from "./QuestionOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports